import { useParams } from "react-router-dom";
import { ContentsTitle } from "src/components";
import HistoryDetail from "src/components/histroy/HistoryDetail";
import MetaTag from "src/components/layout/MetaTag";
import useActiceTab from "src/hooks/useActiceTab";
import { accessGroupTabs } from "../const";
import BasicInfoDetail from "./BasicInfoDetail";
import { useApiOperation } from "src/api/hooks";
import { getAcGroupAsync } from "src/api/access/ac-group-api";
import { useEffect, useState, useCallback } from "react";
import { Ac2AccessGroupModel } from "src/api/access/ac-group-types";
import { getAccessDevicesAsync } from "src/api/access/productac-api";
import { chunk } from "lodash";

const DEVICE_IDS_CHUNK_SIZE = 200;

const AccessGroupDetail = () => {
  const { id: accessGroupId } = useParams();
  const { activeTab } = useActiceTab(accessGroupTabs);

  const { executeAsync: getAcGroup } = useApiOperation(getAcGroupAsync);
  const { executeAsync: getAcDevices } = useApiOperation(getAccessDevicesAsync);

  const [accessGroup, setAccessGroup] = useState<Ac2AccessGroupModel>();

  const getAccessGroupDetail = useCallback(async () => {
    const { data } = await getAcGroup({ id: Number(accessGroupId) });

    // 출입그룹에 등록된 디바이스 조회 > front 용 데이터로 추가
    const devicesIds = data.data.accessGroup.deviceIds;

    if (devicesIds.length > 0) {
      // 한 묶음이 실패해도 나머지 장치로 표시한다. 실패는 훅이 에러 모달로 알린다
      const responses = await Promise.all(
        chunk(devicesIds, DEVICE_IDS_CHUNK_SIZE).map((ids) => getAcDevices({ ids: ids.join(",") }).catch(() => undefined)),
      );
      const acDevices = responses.flatMap((response) => response?.data?.data?.content || []);
      setAccessGroup({ ...data.data.accessGroup, acDevices });
    } else {
      setAccessGroup(data.data.accessGroup);
    }
  }, [accessGroupId, getAcGroup, getAcDevices]);

  useEffect(() => {
    if (accessGroupId) {
      getAccessGroupDetail();
    }
  }, [accessGroupId]);

  return (
    <div>
      <MetaTag subTitle={accessGroupId} />
      <ContentsTitle
        title="출입장치 관리"
        tabs={accessGroupTabs}
        activeTab={activeTab} //
        detailInfo={[{ title: "출입그룹 ID", value: accessGroupId || "" }]}
      />

      {/* 기본정보 */}
      {accessGroup && <>{activeTab?.value === "basicInfo" && <BasicInfoDetail accessGroup={accessGroup} getAcGroup={getAccessGroupDetail} />}</>}

      {/* 변경내역 탭 (AL006 파트너 / AL007 장치, identifier.accessGroupId) */}
      {activeTab?.value === "history" && accessGroupId && <HistoryDetail identifier={{ accessGroupId: String(accessGroupId) }} />}
    </div>
  );
};

export default AccessGroupDetail;
